module.exports = __webpack_public_path__ + "static/01_peeker-1988bc4aaaf24416b942b9bf233e8b4b.gif";